jQuery(document).ready(function($) {
    function applyFontSize() {
        const navContainers = $('.wp-block-navigation__container');
        navContainers.each(function() {
            const fontSize = $(this).css('font-size');
            console.log('fontsize', fontSize);
            $(this).find('a').each(function() {
                this.style.cssText = 'font-size: ' + fontSize + ' !important;';
            });
        });
    }

    // Apply font size on page load
    applyFontSize();

    // Apply font size when editor content changes
    if (typeof wp !== 'undefined' && wp.blocks && wp.data) {
        wp.data.subscribe(function() {
            applyFontSize();
        });
    }
});
